'use client';

import IconButton from 'src/components/primitives/IconButton/IconButton';
import { Open } from '@velocity-exchange/icons';
import { getUrlForTx } from 'src/utils/explorer';

interface ExplorerCellProps {
	txSig: string;
}

export function ExplorerCell({ txSig }: ExplorerCellProps) {
	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		window.open(getUrlForTx(txSig), '_blank', 'noopener,noreferrer');
	};

	return (
		<IconButton
			size="sm"
			variant="tertiary"
			icon={Open}
			onClick={handleClick}
		/>
	);
}
